import * as Theme from "../../../components/styles"
import React from "react"

export const NoEventsMessage = () => (
  <Theme.PageMessage>
    No events to display with the options selected
  </Theme.PageMessage>
)
